@if (data().length === 0) {
  <div class="empty-notes">
    <img
      src="assets/images/empty-note-icon.svg"
      alt="Create The First Note" />
    <div class="empty-notes-title">Create The First Note</div>
  </div>
} @else {
  <p-timeline
    [value]="data()"
    align="left"
    class="note-timeline">
    <ng-template
      #marker
      let-event>
      <span class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1">
        <i [class]="event.icon"></i>
      </span>
    </ng-template>
    <ng-template
      #content
      let-event>
      <p-card
        [header]="event.title"
        [subheader]="event.date">
        <p>
          {{ event.note }}
        </p>
      </p-card>
    </ng-template>
  </p-timeline>
}
